import axios from "axios";
import authentication from "@/authentication";
export default {
  baseUrl: process.env.VUE_APP_API_COURIER_BILLING_SERVICE_BASE,
  async save(formData) {
    await authentication.isAuthenticated();
    return axios.post(`${this.baseUrl}/AuditInvoice`, formData, {
      headers: {
        Authorization: `Bearer ${authentication.getToken()}`
      }
    });
  }
};
